import { restApiMP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiMP.get("/api/mp-scenario-comparison", { params });
};

const release = selectedPlanVersion => {
  return restApiMP.post("/api/mp/release-version", selectedPlanVersion);
};

const mpScenarioComparsionService = {
  getAll,
  release
};

export default mpScenarioComparsionService;